//
// Display Home – "Virtual Tour" CTA in floorplan panel
// Scrolls to the media panel and activates the virtual-tour tab
//

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-scroll-to-virtual-tour]').forEach(button => {
        button.addEventListener('click', () => {
            const mediaSection = document.getElementById('displayHomeMedia');
            if (!mediaSection) return;

            // Scroll to the media panel
            mediaSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

            // Activate the virtual-tour tab
            const virtualTourTab = mediaSection.querySelector('[data-media-tab="virtual-tour"]');
            if (virtualTourTab) {
                virtualTourTab.click();
            }
        });
    });
});
